export const APPLICATION_ROLES = {
  scaniaIt: 'AP3720001-BRSA-CHECKLISTOUTBOUND-SCANIAIT',
  admin: 'AP3720001-BRSA-CHECKLISTOUTBOUND-ADM',
  inspector: 'AP3720001-BRSA-CHECKLISTOUTBOUND-INSPECTOR',
} as const;
